<template>
  <TableLayout :permissions="['business:pricingdetail:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="编码" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="searchForm.creator" placeholder="请输入创建人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间" @change="search"/>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="searchForm.editor" placeholder="请输入编辑人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="searchForm.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="定价方案编码(关联price_param)" prop="pricePramId">
        <el-input v-model="searchForm.pricePramId" placeholder="请输入定价方案编码(关联price_param)" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="车辆类型编码(关联bike_types表）" prop="bikeTypeId">
        <el-input v-model="searchForm.bikeTypeId" placeholder="请输入车辆类型编码(关联bike_types表）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="工作日起步时间（分钟）" prop="baseTime">
        <el-input v-model="searchForm.baseTime" placeholder="请输入工作日起步时间（分钟）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="工作日起步价格（分）" prop="basePrice">
        <el-input v-model="searchForm.basePrice" placeholder="请输入工作日起步价格（分）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="工作日超出时间（分钟）" prop="unitTime">
        <el-input v-model="searchForm.unitTime" placeholder="请输入工作日超出时间（分钟）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="工作日超出价格（分）" prop="unitPrice">
        <el-input v-model="searchForm.unitPrice" placeholder="请输入工作日超出价格（分）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="节假日起步时间（分钟）" prop="holidayBaseTime">
        <el-input v-model="searchForm.holidayBaseTime" placeholder="请输入节假日起步时间（分钟）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="节假日起步价格（分）" prop="holidayBasePrice">
        <el-input v-model="searchForm.holidayBasePrice" placeholder="请输入节假日起步价格（分）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="节假日超出时间（分钟）" prop="holidayUnitTime">
        <el-input v-model="searchForm.holidayUnitTime" placeholder="请输入节假日超出时间（分钟）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="节假日超出时间单价（分）" prop="holidayUnitPrice">
        <el-input v-model="searchForm.holidayUnitPrice" placeholder="请输入节假日超出时间单价（分）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="searchForm.info" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="规则名称" prop="title">
        <el-input v-model="searchForm.title" placeholder="请输入规则名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:pricingdetail:create']">
        <li><el-button type="primary" @click="$refs.operaPricingDetailWindow.open('新建定价方案明细配置')" icon="el-icon-plus" v-permissions="['business:pricingdetail:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="id" label="编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="编辑时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="编辑人" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="pricePramId" label="定价方案编码(关联price_param)" min-width="100px"></el-table-column>
        <el-table-column prop="bikeTypeId" label="车辆类型编码(关联bike_types表）" min-width="100px"></el-table-column>
        <el-table-column prop="baseTime" label="工作日起步时间（分钟）" min-width="100px"></el-table-column>
        <el-table-column prop="basePrice" label="工作日起步价格（分）" min-width="100px"></el-table-column>
        <el-table-column prop="unitTime" label="工作日超出时间（分钟）" min-width="100px"></el-table-column>
        <el-table-column prop="unitPrice" label="工作日超出价格（分）" min-width="100px"></el-table-column>
        <el-table-column prop="holidayBaseTime" label="节假日起步时间（分钟）" min-width="100px"></el-table-column>
        <el-table-column prop="holidayBasePrice" label="节假日起步价格（分）" min-width="100px"></el-table-column>
        <el-table-column prop="holidayUnitTime" label="节假日超出时间（分钟）" min-width="100px"></el-table-column>
        <el-table-column prop="holidayUnitPrice" label="节假日超出时间单价（分）" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="title" label="规则名称" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:pricingdetail:update', 'business:pricingdetail:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaPricingDetailWindow.open('编辑定价方案明细配置', row)" icon="el-icon-edit" v-permissions="['business:pricingdetail:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:pricingdetail:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaPricingDetailWindow ref="operaPricingDetailWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaPricingDetailWindow from '@/components/business/OperaPricingDetailWindow'
export default {
  name: 'PricingDetail',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaPricingDetailWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        pricePramId: '',
        bikeTypeId: '',
        baseTime: '',
        basePrice: '',
        unitTime: '',
        unitPrice: '',
        holidayBaseTime: '',
        holidayBasePrice: '',
        holidayUnitTime: '',
        holidayUnitPrice: '',
        info: '',
        title: ''
      }
    }
  },
  created () {
    this.config({
      module: '定价方案明细配置',
      api: '/business/pricingDetail',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
